export enum WALLET_STATUS {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}
